import { useMemo, useState } from 'react';
import { Settings, LazyLoadTypes } from 'react-slick';
import { CarouselFields, Slide } from '../types/Carouse.types';

export const useCarousel: (
  cardList: CarouselFields['cardList']
) => [Slide[], Settings, boolean] = (cardList) => {
  const [isSliderReady, setIsSliderReady] = useState(false);

  const slides: Slide[] = useMemo(
    () =>
      cardList.map((cardListItem) => {
        return {
          title: cardListItem?.fields?.title?.value,
          preTitle: cardListItem?.fields?.preTitle?.value,
          fullDescription: cardListItem?.fields?.fullDescription?.value,
          linkLabel: {
            value: cardListItem?.fields?.linkUrl?.value?.text,
          },
          videoUrl:
            cardListItem?.fields?.videoUrl?.value?.url &&
            cardListItem.fields.videoUrl.value.url.length > 0
              ? cardListItem.fields.videoUrl.value.url
              : null,
          linkUrl: cardListItem?.fields?.linkUrl?.value?.href,
          imageUrl: cardListItem?.fields?.image?.value?.src,
          imageAlt: cardListItem?.fields?.image?.value?.alt,
          imageMobileAlt: cardListItem?.fields?.imageMobile?.value?.alt,
          imageMobileUrl: cardListItem?.fields?.imageMobile?.value?.src,
          openInNewWindow: ['blank', '_blank'].includes(
            cardListItem?.fields?.linkUrl?.value?.target
          ),
        };
      }),
    [cardList]
  );

  const sliderSettings: Settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      draggable: true,
      adaptiveHeight: false,
      lazyLoad: 'ondemand' as LazyLoadTypes,
      variableWidth: false,
      onInit: () => {
        setTimeout(() => {
          setIsSliderReady(true);
        }, 350);
      },
    }),
    []
  );

  return [slides, sliderSettings, isSliderReady];
};
